import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C8B18CF5-BD7E-41FC-A653-6B46D85F982A
 * name vector-point-select
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point-select.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorPointSelectIcon = createSvgIcon(<><path d="M12,20L7,22L12,11L17,22L12,20M8,2H16V5H22V7H16V10H8V7H2V5H8V2M10,4V8H14V4H10Z" /></>, 'VectorPointSelectIcon');
export default VectorPointSelectIcon